<template>
    <aside class="podcast-player-wrapper">
        <div class="podcast-player__info" v-if="isLessThan530">
            <div class="podcast-player__picture-wrapper">
                <img class="podcast-player__picture" :src="currentPodcast.picture" />
            </div>
            <p class="podcast-player__info-title">
                {{ currentPodcast.title }}
            </p>
        </div>
        <div class="podcast-player__track" v-if="isLessThan710">
            <span class="podcast-player__track-time">
                {{ currentTime }}
            </span>
            <v-slider class="podcast-player__track-slider" 
                v-model="track" 
                :max="trackLength" 
                :color="sliderColor"
                track-color="#9B9B9B" 
                thumb-color="#fff" 
                hide-details 
                :ripple="false" 
                @change="handleTrackClick"
                @mousedown="handleTrackDown" 
                @mouseup="handleTrackUp"
                @touchstart="handleTrackDown" 
                @touchend="handleTrackUp" 
            />
            <span class="podcast-player__track-time">
                {{ remainingTime }}
            </span>
        </div>
        <div class="podcast-player">
            <div class="podcast-player__info" v-if="!isLessThan530">
                <div class="podcast-player__picture-wrapper">
                    <img class="podcast-player__picture" :src="pictureSrc" />
                </div>
                <p class="podcast-player__info-title">
                    {{ currentPodcast.title }}
                </p>
            </div>
            <div class="podcast-player__controls">
                <v-btn class="podcast-player__controls-next elevation-0" @click="prevTrack">
                    <v-icon class="podcast-player__controls-next-icon" size="medium">
                        mdi-skip-backward
                    </v-icon>
                </v-btn>
                <v-btn class="podcast-player__controls-play elevation-0" @click="handleClickPlay">
                    <v-icon class="podcast-player__controls-play-icon">
                        {{ $refs.audioPlayer && !$refs.audioPlayer.paused ? 'mdi-pause' : 'mdi-play' }}
                    </v-icon>
                </v-btn>
                <v-btn class="podcast-player__controls-next elevation-0" @click="nextTrack">
                    <v-icon class="podcast-player__controls-next-icon" size="medium">
                        mdi-skip-forward
                    </v-icon>
                </v-btn>
            </div>
            <div class="podcast-player__track" v-if="!isLessThan710">
                <span class="podcast-player__track-time">
                    {{ currentTime }}
                </span>
                <v-slider 
                    class="podcast-player__track-slider" 
                    v-model="track" 
                    :max="trackLength" 
                    :color="sliderColor"
                    track-color="#9B9B9B" 
                    thumb-color="#fff" 
                    hide-details 
                    :ripple="false" 
                    @change="handleTrackClick"
                    @mousedown="handleTrackDown" 
                    @mouseup="handleTrackUp"  
                />
                <span class="podcast-player__track-time">
                    {{ remainingTime }}
                </span>
            </div>
            <div class="podcast-player__volume">
                <v-btn class="podcast-player__volume-btn elevation-0" @click="minVolume">
                    <v-icon class="podcast-player__volume-icon">
                        mdi-volume-mute
                    </v-icon>
                </v-btn>
                <v-slider 
                    class="podcast-player__volume-slider" 
                    v-model="volume" 
                    :color="sliderColor"
                    track-color="#9B9B9B" 
                    thumb-color="transparent" 
                    hide-details 
                    :ripple="false"
                    direction="vertical"
                />
                <v-btn class="podcast-player__volume-btn elevation-0" @click="maxVolume">
                    <v-icon class="podcast-player__volume-icon">
                        mdi-volume-high
                    </v-icon>
                </v-btn>
            </div>
        </div>
        <audio :src="currentPodcast.upload.url" ref="audioPlayer" autoplay />
        <v-btn class="podcast-player__close-btn elevation-0" @click="closePlayer">
            <v-icon class="podcast-player__close-btn-icon" size="large">
                mdi-close
            </v-icon>
        </v-btn>
    </aside>
</template>
<script>
import podcastImg from '@/assets/images/podcast.svg'
import { mapActions, mapGetters } from 'vuex';
export default {
    data() {
        return {
            track: 0,
            trackLength: 100,
            volume: 50,
            prevVolume: 50,
            podcastImg
        }
    },
    methods: {
        ...mapActions('rss', ['togglePlay', 'nextPodcast', 'prevPodcast', 'closePodcastPlayer']),

        handleClickPlay() {
            this.togglePlay(!this.play)
        },
        handleTrackClick(value) {
            this.$refs.audioPlayer.currentTime = value
        },
        audioPlay() {
            this.$refs.audioPlayer.play()
        },
        audioPause() {
            this.$refs.audioPlayer.pause()
        },
        handleTimeupdate() {
            this.track = this.$refs.audioPlayer.currentTime
        },
        handleTrackDown() {
            this.$refs.audioPlayer.removeEventListener('timeupdate', this.handleTimeupdate)
        },
        handleTrackUp() {
            this.$refs.audioPlayer.addEventListener('timeupdate', this.handleTimeupdate)
        },
        initMetadata(e) {
            this.trackLength = e.target.duration
            this.$refs.audioPlayer.removeEventListener('loadedmetadata', this.initMetadata)
        },
        minVolume() {
            if (this.volume !== 0) {
                this.prevVolume = this.volume
                this.volume = 0
            } else {
                this.volume = this.prevVolume
            }
        },
        maxVolume() {
            if (this.volume !== 100) {
                this.prevVolume = this.volume
                this.volume = 100
            } else {
                this.volume = this.prevVolume
            }
        },
        nextTrack() {
            if (this.podcastNumber + 1 < this.playlist.length) {
                this.nextPodcast()
            }
        },
        prevTrack() {
            if (this.podcastNumber !== 0) {
                this.prevPodcast()
            }
        },
        closePlayer() {
            this.closePodcastPlayer()
        }
    },
    computed: {
        ...mapGetters('rss', ['play', 'currentPodcast', 'playlist', 'podcastNumber']),
        ...mapGetters('settings', ['styles']),

        pictureSrc() {
            return this.currentPodcast.picture || this.podcastImg
        },
        sliderColor() {
            if (this.styles) {
                return this.styles.navigation_bar_tint
            }
            return "#000"
        },
        isLessThan710() {
            return this.$vuetify.breakpoint.width <= 710
        },
        isLessThan530() {
            return this.$vuetify.breakpoint.width <= 530
        },
        currentTime() {
            const seconds = this.track
            const minutes = Math.floor(seconds / 60)
            const remainingSeconds = seconds % 60
            const minutesString = (minutes < 10) ? "0" + minutes : minutes
            const secondsString = (remainingSeconds < 10) ? "0" + remainingSeconds : remainingSeconds
            if (!isNaN(minutesString) && !isNaN(secondsString)) {
                return minutesString + ":" + secondsString
            }
            return '00:00'
        },
        remainingTime() {
            const seconds = Math.floor(this.trackLength) - this.track
            const minutes = Math.floor(seconds / 60)
            const remainingSeconds = seconds % 60
            const minutesString = (minutes < 10) ? "0" + minutes : minutes
            const secondsString = (remainingSeconds < 10) ? "0" + remainingSeconds : remainingSeconds
            if (!isNaN(minutesString) && !isNaN(secondsString)) {
                return minutesString + ":" + secondsString
            }
            return '00:00'
        }
    },
    watch: {
        play(newValue) {
            newValue ? this.audioPlay() : this.audioPause()
        },
        volume(newValue) {
            this.$refs.audioPlayer.volume = newValue / 100
        },
        currentPodcast() {
            this.$refs.audioPlayer.addEventListener('loadedmetadata', this.initMetadata)
        }
    },
    mounted() {
        this.handleTrackUp()
        this.$refs.audioPlayer.addEventListener('loadedmetadata', this.initMetadata)
        if (!this.play) {
            this.togglePlay(true)
        }
    },
    beforeDestroy() {
        this.handleTrackDown()
    },
}
</script>
<style lang="scss">
.podcast-player {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 30px;
    width: 100%;
    max-width: 1160px;
    position: relative;

    @media (max-width: 840px) {
        column-gap: 10px;
    }

    @media (max-width: 710px) {
        column-gap: 30px;
    }

    &-wrapper {
        position: fixed !important;
        top: 100%;
        transform: translateY(-100%);
        z-index: 5;
        height: 100px;
        width: 100%;
        padding: 0 16px;
        background: rgba(255, 255, 255, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;

        /* &-hidden {
            top: calc(100% + 100px);

            @media (max-width: 710px) {
                top: calc(100% + 150px);
            }

            @media (max-width: 530px) {
                top: calc(100% + 200px);
            }
        } */

        @media (max-width: 710px) {
            height: 150px;
            flex-direction: column;
            justify-content: space-around;
        }

        @media (max-width: 530px) {
            height: 200px;
        }
    }

    &__info {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;

        @media (max-width: 530px) {
            width: 100%;
            justify-content: center;
        }

        &-title {
            margin: 0 !important;
            font-size: 13px;
            font-weight: 700;
            line-height: 19.37px;
            color: var(--accent-color);
            font-family: Montserrat, sans-serif;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            max-width: 178px;

            @media (max-width: 530px) {
                max-width: none;
            }
        }
    }

    &__picture {
        height: 60px;
        width: 60px;
        background: #AAA;
        object-fit: cover;
        border-radius: 8px;

        &-wrapper {
            display: flex;
            align-items: center;
            margin-right: 12px;
        }
    }

    &__controls {
        display: flex;
        align-items: center;
        column-gap: 16px;

        &-play {
            background-color: var(--accent-color) !important;
            border-radius: 50%;
            min-width: auto !important;
            width: 52px;
            height: 52px !important;
            border: 2px solid #fff;

            &-icon {
                color: #fff !important;
            }
        }
        &-next {
            min-width: auto !important;
            width: 20px;
            height: 20px;
            background-color: transparent !important;

            &-icon {
                color: var(--accent-color) !important;
            }
        }
    }

    &__track {
        flex-grow: 1;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;

        @media (max-width: 710px) {
            flex-grow: 0;
            width: 100%;
        }

        &-time {
            width: 35px;
            font-size: 14px;
            font-weight: 500;
            font-family: Montserrat, sans-serif;
            color: #9B9B9B;
            line-height: 17.07px;
        }

        &-slider {
            margin: 0 16px;
            min-width: 170px;

            @media (max-width: 840px) {
                min-width: 100px;
            }

            .v-slider {
                margin: 0 !important;
            }
        }

        .v-slider__thumb {
            height: 26px !important;
            width: 26px !important;
            box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
        }
    }

    &__volume {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;

        &-slider {
            margin: 0 16px;
            width: 170px;

            @media (max-width: 1200px) {
                width: 60px;
            }

            .v-slider {
                margin: 0 !important;
            }
        }

        &-btn {
            min-width: auto !important;
            width: 20px;
            height: 20px;
            background-color: transparent !important;
        }
        &-icon {
            color: var(--accent-color) !important;
        }
    }

    &__close-btn {
        position: absolute;
        top: 0;
        right: 0;
        background-color: transparent !important;
        min-width: auto !important;
        width: 36px;
        height: 36px;

        &-icon {
            color: var(--accent-color) !important;
        }
    }
}
</style>